import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { TableModel } from 'src/app/models/table.model';
import { PagedPendingGroupedModel } from '../models/paged.pending.grouped.model';
import { isNullOrUndefined } from 'util';
import { PagedRawImageDetailModel } from '../models/paged.raw.image.detail.model';

@Injectable()
export class RawImageService {

  constructor(private http: HttpClient) { }

  pendingGroupedList(tableModel: TableModel): Observable<PagedPendingGroupedModel> {
    let url = `${environment.apiUrl}/api/editor/rawImage/pending-grouped-list`;
    const tempArr = [];
    if (tableModel) {
      tempArr.push(tableModel.toQueryString());
    }
    if (tempArr.length) {
      url += '?' + tempArr.join('&');
    }
    return this.http.get<PagedPendingGroupedModel>(url);
  }

  accept(unixTimeStamp: number) {
    return this.http.post(`${environment.apiUrl}/api/editor/rawImage/accept/${unixTimeStamp}`, null);
  }

  reject(unixTimeStamp: number) {
    return this.http.post(`${environment.apiUrl}/api/editor/rawImage/reject/${unixTimeStamp}`, null);
  }

  getList(unixTimeStamp: number, tableModel: TableModel): Observable<PagedRawImageDetailModel> {
    let url = `${environment.apiUrl}/api/editor/rawImage/list`;
    const queryParams = [];
    if (!isNullOrUndefined(unixTimeStamp)) {
      queryParams.push(`unixTimeStamp=${unixTimeStamp}`);
    }
    if (tableModel) {
      queryParams.push(tableModel.toQueryString());
    }
    if (queryParams.length) {
      url += '?' + queryParams.join('&');
    }
    return this.http.get<PagedRawImageDetailModel>(url);
  }

  markAsProcessed(rawImageIds: Array<string>) {
    return this.http.post(`${environment.apiUrl}/api/editor/rawImage/mark-as-processed`, rawImageIds);
  }
}
